import styled from "styled-components";
import { DataTypes } from "../../rule-engine-core/Common/Data/DataTypes";
import { IDisplayModeValueEditor } from "./Common";
import type { AppGlueAny } from "../../rule-engine-core/Common/AppGlueAny";

export const ListValueRender = ({ values, length = 15 }: { values: AppGlueAny[]; length?: number }) => {
    let requiredLength: boolean = false;
    let renderValue = values.reduce((s, current, index) => {
        if (index === 0) return `${current}`;
        if (`${s}, ${current}`.length > length) {
            requiredLength = true;
            return s;
        }
        s = `${s}, ${current}`;
        return s;
    }, "");

    if (renderValue === "") {
        renderValue = "items...";
    }

    return (
        <>
            {renderValue} {requiredLength ? `... (${values.length})` : ``}
        </>
    );
};

export const DisplayModeValueEditor = ({ value, forData }: IDisplayModeValueEditor) => {
    let valueStr = value !== null && value !== undefined ? `${value}` : "";

    if (valueStr === "") {
        valueStr = `${forData.name}...`;
    }

    return (
        <StyledDisplayModeValueRender
            className="ValueEditor-display"
            data-testid="ValueEditor-Display"
            isRightAlign={forData.type === DataTypes.NUMBER && !forData.list}
        >
            {Array.isArray(value) ? (
                <ListValueRender values={value} />
            ) : (
                <>{valueStr.length > 15 ? `${valueStr.slice(0, 15)}...` : valueStr}</>
            )}
        </StyledDisplayModeValueRender>
    );
};

const StyledDisplayModeValueRender = styled.div<{ isRightAlign?: boolean }>`
    display: flex;
    align-items: center;

    ${(props) =>
        props.isRightAlign
            ? `
                justify-content: flex-end;
                width: 100%;
            `
            : ""}
`;
